import { gql } from '@apollo/client';

export default gql`
  mutation confirmPutOnHold($bookingReference: String!) {
    putOnHold(bookingReference: $bookingReference) {
      reference
      status
    }

    confirmOnHold(bookingReference: $bookingReference) {
      reference
      status
      onHold {
        expiryTimestamp
      }
    }
  }
`;
